module.exports = __webpack_public_path__ + "img/3_en.59ef927a.jpg";